<template>
  <div>
    <!-- PC, タブレット -->
    <div class="pc-block">
      <div :class="{'planSelectPrepareBoxes': isFlex}">
        <!-- プラン1 -->
        <div :class="{'planSelectPrepareBox': isFlex, 'plan-left': isFlex}">
          <p v-show="!canSelectRegularPlan && showRegularPlan" class="planSelectPrepareBoxText">準備中</p>
        </div>
        <!-- プラン2 -->
        <div :class="{'planSelectPrepareBox': isFlex}">
          <p v-show="!canSelectGoldPlan && showGoldPlan" class="planSelectPrepareBoxText">準備中</p>
        </div>
        <!-- プラン3 -->
        <div :class="{'planSelectPrepareBox': isFlex}">
          <p v-show="!canSelectPlatinumPlan && showPlatinumPlan" class="planSelectPrepareBoxText">準備中</p>
        </div>
      </div>

      <!-- プラン説明部分 -->
      <div :class="{'planSelectPrepareBoxes': isFlex}">
        <!-- プラン1 -->
        <div :class="{'planSelectDescBox': true, 'is-flex': isFlex, ' plan-left': isFlex, 'disable':this.disableRegularPlan, 'is-hidden': !showRegularPlan}" @click="selectRegularPlan()">
          <div>
            <h4 :class="{'planSelectDescBoxTitle':true, 'disable':this.disableRegularPlan}">{{ regularPlanTitle }}</h4>
            <img :class="{'planSelectImageBoxImg':true, mt20:true}" :src="regularPlanImagePath" v-if="hasRegularPlanImage">
          </div>
          <div class="tiny_textbox" v-if="regularPlanBody" v-html="regularPlanBody"></div>
        </div>

        <!-- プラン2 -->
        <div :class="{'planSelectDescBox': true, 'is-flex': isFlex, ' plan-left': isFlex, 'disable':this.disableGoldPlan, 'is-hidden': !showGoldPlan}" @click="selectGoldPlan()">
          <div>
            <h4 :class="{'planSelectDescBoxTitle':true, 'disable':this.disableGoldPlan}">{{ goldPlanTitle }}</h4>
            <img :class="{'planSelectImageBoxImg':true, mt20:true}" :src="goldPlanImagePath" v-if="hasGoldPlanImage">
          </div>
          <div class="tiny_textbox" v-if="goldPlanBody" v-html="goldPlanBody"></div>
        </div>

        <!-- プラン3 -->
        <div :class="{'planSelectDescBox': true, 'is-flex': isFlex, 'disable':this.disablePlatinumPlan, 'is-hidden': !showPlatinumPlan}" @click="selectPlatinumPlan()">
          <div>
            <h4 :class="{'planSelectDescBoxTitle':true, 'disable':this.disablePlatinumPlan}">{{ platinumPlanTitle }}</h4>
            <img :class="{'planSelectImageBoxImg':true, mt20:true}" :src="platinumPlanImagePath" v-if="hasPlatinumPlanImage">
          </div>
          <div class="tiny_textbox" v-if="platinumPlanBody" v-html="platinumPlanBody"></div>
        </div>
      </div>
    </div>

    <!-- スマホ -->
    <div class="sp-block">
      <div class="mb20">
        <!-- プラン1 -->
        <div @click="selectRegularPlan()" :class="{'planSelectFormItems': true}" v-show="showRegularPlan">
          <h4 class="planSelectDescBoxTitle">{{ regularPlanTitle }}</h4>
          <img class="planSelectImageBoxImg mt10" :src="regularPlanImagePath">
          <span v-show="!canSelectRegularPlan" class="planSelectFormItemsPrepare">準備中</span>
          <div class="tiny_textbox" v-if="regularPlanBody" v-html="regularPlanBody"></div>
        </div>

        <!-- プラン2 -->
        <div @click="selectGoldPlan()" :class="{'planSelectFormItems': true}" v-show="showGoldPlan">
          <h4 class="planSelectDescBoxTitle">{{ goldPlanTitle }}</h4>
          <img class="planSelectImageBoxImg mt10" :src="goldPlanImagePath">
          <span v-show="!canSelectGoldPlan" class="planSelectFormItemsPrepare">準備中</span>
          <div class="tiny_textbox" v-if="goldPlanBody" v-html="goldPlanBody"></div>
        </div>

        <!-- プラン3-->
        <div @click="selectPlatinumPlan()" :class="{'planSelectFormItems': true}" v-show="showPlatinumPlan">
          <h4 class="planSelectDescBoxTitle">{{ platinumPlanTitle }}</h4>
          <img class="planSelectImageBoxImg mt10" :src="platinumPlanImagePath">
          <span v-show="!canSelectPlatinumPlan" class="planSelectFormItemsPrepare">準備中</span>
          <div class="tiny_textbox" v-if="platinumPlanBody" v-html="platinumPlanBody"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'

  export default {
    props: [
      'plan',
      'showRegularPlan',
      'showGoldPlan',
      'showPlatinumPlan',
      'canSelectRegularPlan',
      'canSelectGoldPlan',
      'canSelectPlatinumPlan',
      'hasRegularPlanImage',
      'hasGoldPlanImage',
      'hasPlatinumPlanImage',
      'regularPlanImagePath',
      'goldPlanImagePath',
      'platinumPlanImagePath',
    ],

    data () {
      return {
        objPlan: JSON.parse(this.plan),
        regularPlanTitle: '',
        goldPlanTitle: '',
        platinumPlanTitle: '',
        regularPlanBody: '',
        goldPlanBody: '',
        platinumPlanBody: '',
        disableRegularPlan: !this.canSelectRegularPlan,
        disableGoldPlan: !this.canSelectGoldPlan,
        disablePlatinumPlan: !this.canSelectPlatinumPlan,
        isFlex: true
      }
    },

    methods: {
      selectRegularPlan () {
        if (!this.canSelectRegularPlan) {
          return false
        }

        axios.get('/set-after-login', {
          params: {
            url: '/register/corporate_plan?type=regular'
          }
        }).then(res => {
          window.location.href = '/register/corporate_plan?type=regular'
        }).catch(error => {
          console.log(error)
        })
      },

      selectGoldPlan () {
        if (!this.canSelectGoldPlan) {
          return false
        }

        axios.get('/set-after-login', {
          params: {
            url: '/register/corporate_plan?type=gold'
          }
        }).then(res => {
          window.location.href = '/register/corporate_plan?type=gold'
        }).catch(error => {
          console.log(error)
        })
      },

      selectPlatinumPlan () {
        if (!this.canSelectPlatinumPlan) {
          return false
        }

        axios.get('/set-after-login', {
          params: {
            url: '/register/corporate_plan?type=platinum'
          }
        }).then(res => {
          window.location.href = '/register/corporate_plan?type=platinum'
        }).catch(error => {
          console.log(error)
        })
      },
    },

    mounted () {
      this.regularPlanTitle = this.objPlan.corporate_plan1_title
      this.goldPlanTitle = this.objPlan.corporate_plan2_title
      this.platinumPlanTitle = this.objPlan.corporate_plan3_title
      this.regularPlanBody = this.objPlan.corporate_plan1_body
      this.goldPlanBody = this.objPlan.corporate_plan2_body
      this.platinumPlanBody = this.objPlan.corporate_plan3_body
    }
  }
</script>

<style lang="scss" scoped>
  .is-hidden {display:none;}
  .disable {color:white !important;background-color:#CCCCCC !important;cursor:inherit;}
  .planSelectDescBoxTitle {color:rgb(32,32,32)}
</style>